import { Category } from "@/types";
import { useState } from "react";
import { useForm, Controller } from "react-hook-form";
import { PiXLight } from "react-icons/pi";
import { Button, Modal, ActionIcon, Input, Textarea, Text } from "rizzui";

interface AddCategoryProps {
    show: boolean;
    handleSave: (category: Category) => void;
    title: string;
    description?: string;
}

const AddCategoryModal: React.FC<AddCategoryProps> = ({
    title,
    description,
    handleSave,
}) => {
    const [modalState, setModalState] = useState(false);

    const { control, handleSubmit, reset } = useForm<Category>({
        defaultValues: {
            id: "",
            name: "",
            description: "",
        },
    });

    const onSubmit = (data: Category) => {
        handleSave(data);
        reset();
        setModalState(false);
    };

    return (
        <>
            <Button onClick={() => setModalState(true)}>Add Category</Button>
            <Modal isOpen={modalState} onClose={() => setModalState(false)}>
                <div className="m-auto px-7 pt-6 pb-8">
                    <div className="mb-7 flex items-center justify-between">
                        <div className="flex flex-col ">
                            <Text className="text-lg font-semibold h3">
                                {title}
                            </Text>
                            <p className="text-sm text-gray-500">
                                {description}
                            </p>
                        </div>
                        <ActionIcon
                            size="sm"
                            variant="text"
                            onClick={() => setModalState(false)}
                        >
                            <PiXLight
                                className="h-auto w-6"
                                strokeWidth={1.8}
                            />
                        </ActionIcon>
                    </div>
                    <form onSubmit={handleSubmit(onSubmit)}>
                        <label>Name</label>
                        <div className="mb-4 mt-2">
                            <Controller
                                name="name"
                                control={control}
                                render={({ field }) => <Input {...field} />}
                            />
                        </div>

                        <label>Description</label>
                        <div className="mb-4 mt-2">
                            <Controller
                                name="description"
                                control={control}
                                render={({ field }) => (
                                    <Textarea rows={3} {...field} />
                                )}
                            />
                        </div>
                        <div className="flex justify-end gap-4">
                            <Button
                                variant="outline"
                                color="secondary"
                                onClick={() => setModalState(false)}
                            >
                                Cancel
                            </Button>
                            <Button type="submit">Add Category</Button>
                        </div>
                    </form>
                </div>
            </Modal>
        </>
    );
};


export default AddCategoryModal;